import DesenvolvimentoInfantilIcon from '@/components/icons/IndicadoresAps/eSFeAP/DesenvolvimentoInfantil.vue'

export default {
  value: 'c2',
  label: 'Desenvolvimento infantil',
  iconType: 'component',
  iconComponent: DesenvolvimentoInfantilIcon,
  buscaAtiva: {
    a: 'Criança sem 1ª consulta presencial médica ou de enfermagem até o 30º dia de vida.',
    b: 'Criança deveria ter consultas (medicina + enfermagem) até o momento.',
    c: 'Criança deveria ter medições de peso e altura até o momento.',
    d: 'O recém-nascido deveria ter recebido pelo menos uma visita domiciliar do ACS/TACS até completar 30 dias de vida.',
    e: 'Criança deveria ter sido vacinada contra difteria, tétano, coqueluche, hepatite B, infecções causadas por Haemophilus Influenzae tipo B, poliomielite, sarampo, caxumba e rubéola, com todas as doses recomendadas.',
  },
}
